import * as React from 'react';
import { useMatch } from 'react-router-dom';
import styled from 'styled-components';
import { useQuery } from 'urql';

import Loader from '../../shared/components/Loader';
import TaskDescription from '../../shared/components/TaskDescription';
import { TaskIcon } from '../../shared/types';
import Error from '../components/Error';

interface IArgs {
    id: string;
}

const query = `
    query($id:String!) {
        event(id:$id) {
            id
            icon
            shortTitle
            title
            inspiration {
                id
                mediaType
                src
            }
            media {
                id
                mediaType
                src
                name
                logo
            }
            eventStart
            eventEnd
            objectives
            description
        }
    }
`;

interface IEvent {
    id: string;
    icon: TaskIcon;
    shortTitle: string;
    title: string | null;
    inspiration: {
        id: string;
        mediaType: string;
        src: string;
    } | null;
    media: {
        id: string;
        mediaType: string;
        src: string;
        name: string;
        logo: string;
    }[];
    eventStart: string;
    eventEnd: string;
    objectives: string | null;
    description: string | null;
}

interface IData {
    event: IEvent;
}

const Wrapper = styled.main`
    padding: 0 15px;
    flex-grow: 1;
    max-width: 1030px;
    width: 100%;
`;

function Event(): JSX.Element {
    const { params: { id } } = useMatch({ path: '/event/:id/' });
    const [result] = useQuery<IData, IArgs>({
        query,
        requestPolicy: 'network-only',
        variables: { id },
    });

    let main = null;
    if (result.fetching) {
        main = <Loader />;
    } else if (result.error) {
        main = <Error />;
    } else {
        const event = result.data.event;
        main = <>
            <TaskDescription
                shortTitle={event.shortTitle}
                objectives={event.objectives}
                inspiration={event.inspiration}
                title={event.title}
                icon={event.icon}
                miles={null}
                media={event.media}
                eventStart={event.eventStart}
                eventEnd={event.eventEnd}
                taskVariants={[]}
                invert={false}
                description={event.description}
            />
        </>;
    }
    return <Wrapper>
        {main}
    </Wrapper>;
}

export default Event;
